import { render, staticRenderFns } from "./AdminSupplierAttributions.vue?vue&type=template&id=a8ee6182&scoped=true&"
import script from "./AdminSupplierAttributions.vue?vue&type=script&lang=js&"
export * from "./AdminSupplierAttributions.vue?vue&type=script&lang=js&"
import style0 from "./AdminSupplierAttributions.vue?vue&type=style&index=0&id=a8ee6182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ee6182",
  null
  
)

export default component.exports